import { ACTION_TYPE } from '../actions/actionTypes';

const {
  FORM_OPTION_SUCCESS, FORM_OPTION_FAIL, FORM_SUBMIT_CLICK, FORM_SUBMIT_INIT,
} = ACTION_TYPE;

const formOptionReducer = (state = {}, action) => {
  switch (action.type) {
    case FORM_OPTION_SUCCESS:
      return { ...state, formOptions: action.payload, error: null };
    case FORM_OPTION_FAIL:
      return { ...state, formOptions: null, error: action.payload };
    case FORM_SUBMIT_CLICK:
      return { ...state, isSubmitClicked: true };
    case FORM_SUBMIT_INIT:
      return { ...state, isSubmitClicked: false };
    default:
      return state;
  }
};

export default formOptionReducer;
